module.exports = __webpack_public_path__ + "img/gnjs2.45e53fe8.png";